var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.isPremium)?_c('v-chip',{staticClass:"mx-1",attrs:{"x-small":"","color":"warning"},on:{"click":_vm.upgrade}},[(_vm.isTrial)?_c('strong',{staticClass:"text-body-2 mc-font"},[_vm._v(_vm._s(_vm.$t('upgradeFromTrial')))]):_c('strong',{staticClass:"text-body-2 mc-font"},[_vm._v(_vm._s(_vm.$t('premium')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }